import { render, staticRenderFns } from "./CreatePrivateRate.vue?vue&type=template&id=11ec87cc&scoped=true&"
import script from "./CreatePrivateRate.vue?vue&type=script&setup=true&lang=ts&"
export * from "./CreatePrivateRate.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./CreatePrivateRate.vue?vue&type=style&index=0&id=11ec87cc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11ec87cc",
  null
  
)

export default component.exports